<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="fixed inset-0 z-50 !mt-0 flex items-center justify-center overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <div class="relative m-6 flex w-[700px] transform select-none flex-col items-center rounded-md bg-white transition-all dark:bg-bodyblack md:m-0">
    <div class="w-full p-3 md:p-6">
      <h1 class="text-center text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Signer Name Mismatch</h1>
    </div>

    <div class="w-full break-words p-3 text-gray-400 dark:text-gray-200 mobile:p-6 md:w-4/5">
      The signer name does not match with the <span class="font-bold">Common Name (CN)</span>
      in the digital signature certificate.

      <ul class="mt-4 list-disc space-y-2 pl-5">
        <li>
          Click
          <span class="text-red-500">Reject</span>
          to decline the approval. The Docket will be marked as Rejected.
        </li>

        <li>
          Click
          <span class="text-yellow-500">Update</span>
          to replace the signer name with the certificate’s CN.
        </li>

        <li>
          Click
          <span class="text-green-500">Approve</span>
          to proceed without making any changes despite the mismatch.
        </li>
      </ul>
    </div>

    <div class="flex items-center justify-center gap-3 p-2 md:p-4">
      <button on:click={() => dispatch("close")} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-transparent px-3 py-1.5 text-sm font-medium text-white hover:bg-red-500 focus:outline-none sm:w-auto">
        <span><i class="fa-solid fa-xmark" /></span>
        <span class="select-none">&nbsp;&nbsp;Close&nbsp;&nbsp;</span>
      </button>

      <button on:click={() => dispatch("handleCN", { state: "REJECT" })} type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-red-500 px-3 py-1.5 text-sm font-medium text-white focus:outline-none sm:w-auto">
        <span><i class="fa-solid fa-ban" /></span>
        <span class="select-none">&nbsp;&nbsp;Reject&nbsp;&nbsp;</span>
      </button>

      <button type="button" on:click={() => dispatch("handleCN", { state: "CHANGE_CN_NAME" })} class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-yellow-500 px-3 py-1.5 text-sm font-medium text-white focus:outline-none sm:w-auto">
        <span><i class="fa-solid fa-pen" /></span>
        <span class="select-none">&nbsp;&nbsp;Update&nbsp;&nbsp;</span>
      </button>

      <button type="button" on:click={() => dispatch("handleCN", { state: "APPROVE" })} class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-3 py-1.5 text-sm font-medium text-white focus:outline-none sm:w-auto">
        <span><i class="fa-solid fa-check" /></span>
        <span class="select-none">&nbsp;&nbsp;Approve&nbsp;&nbsp;</span>
      </button>
    </div>
  </div>
</div>
